var map = {
	"./bg.jpg": 104,
	"./causal-clustering-drivers.svg": 105,
	"./cloud_dev_img.svg": 106,
	"./contact.svg": 107,
	"./custom_dev_img.svg": 108,
	"./dev.svg": 109,
	"./dev_ops_img.svg": 110,
	"./female developer 2-01.jpg": 111,
	"./footer_bg_img.svg": 69,
	"./globe.jpg": 112,
	"./hero.svg": 113,
	"./hero_img_1.svg": 58,
	"./hmd.svg": 114,
	"./hosting.svg": 115,
	"./image1.jpg": 116,
	"./image2.jpg": 117,
	"./image3.jpg": 118,
	"./image4.jpg": 119,
	"./image5.png": 120,
	"./kaithero.svg": 121,
	"./legacy_system_img.svg": 122,
	"./logo (copy).svg": 123,
	"./logo.png": 41,
	"./logo.svg": 77,
	"./mobile_cross_dev_img.svg": 124,
	"./mobile_dev_img.jpg": 125,
	"./mobile_dev_img.svg": 126,
	"./mobile_native_dev_img.svg": 127,
	"./mobile_native_dev_img1.svg": 128,
	"./mobile_native_dev_img2.svg": 129,
	"./speed.svg": 130,
	"./vr.png": 131,
	"./vr_dev_img.svg": 132,
	"./vr_img.png": 133,
	"./web_dev_img.svg": 134,
	"./web_hosting_img.svg": 135,
	"./webhosting.svg": 136,
	"./why_img.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;